import useStyles from './styles';
import { isIOS, isMobile } from 'utils';
import {
  Button,
  ClassNameMap,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import { IosShare } from '@mui/icons-material';
import { Trans, useTranslation } from 'react-i18next';
import IconStyled from 'components/icons-styled';

interface InstallationPopupProps {
  onInstall?: () => void;
  onClose: () => void;
}

const InstallationPopup = ({ onInstall, onClose }: InstallationPopupProps) => {
  const { t } = useTranslation();
  const classes: ClassNameMap = useStyles();

  return (
    <Dialog
      open={true}
      disableEnforceFocus
      className={classes.dialogContainer}
      fullScreen={isMobile()}
    >
      <DialogContent sx={{ paddingBottom: '16px', paddingTop: '16px' }}>
        <div className={classes.content}>
          <div className={classes.titleContent}>
            <IconStyled
              customHoverStyles={{
                backgroundColor: 'rgb(98 109 249 / 20%)!important',
                '& *': {
                  backgroundColor: 'transparent!important',
                },
              }}
            >
              <img
                alt="logo"
                src={'/images/app-icon.svg'}
                className={classes.appIcon}
              />
            </IconStyled>
            <Typography variant="h5">
              {t('common:install_sds_manager_app')}
            </Typography>
          </div>
          <Typography variant="body1">
            {t('common:app_provides_offline_access')}
          </Typography>
          <Typography variant="body1">
            {t('common:it_will_automatically_check_for_updates')}
          </Typography>
          {isIOS() && (
            <Typography variant="body1" color={'primary'}>
              <Trans
                ns={'common'}
                i18nKey={'to_install_this_app'}
                components={[
                  <IosShare
                    sx={{ margin: '0px 4px', position: 'relative', top: '3px' }}
                  />,
                ]}
              />
            </Typography>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <div className={classes.actionContainer}>
          {!isIOS() || onInstall !== undefined ? (
            <>
              <Button
                className={classes.actionBtn}
                onClick={onInstall}
                variant="contained"
              >
                {t('common:install')}
              </Button>
              <Button
                className={classes.actionBtn}
                onClick={onClose}
                variant="outlined"
              >
                {t('common:remind_me_later')}
              </Button>
            </>
          ) : (
            <Button
              className={classes.actionBtn}
              onClick={onClose}
              variant="contained"
            >
              {t('common:got_it')}
            </Button>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default InstallationPopup;
